/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import classnames from 'classnames';

import HorizontalScrollIndicators from 'components/uiLibrary/HorizontalScrollIndicators';
import Typography from 'components/uiLibrary/Typography';

import { createDate } from 'utils/date';
import { groupPerformancesDatesByYear } from 'utils/productions';

import classes from './ProductionCalendarDates.module.scss';

const ProductionCalendarDates = ({ production, selectedPerformanceId, setSelectedPerformanceId }) => {
  const allDates = groupPerformancesDatesByYear(production?.performances);

  const handleDateClick = date => {
    setSelectedPerformanceId(date);
  };

  return (
    <HorizontalScrollIndicators
      triggerSize={0}
      isArrowsEnabled
      styles={{ leftIndicator: classes.scrollLeftIndicator, rightIndicator: classes.scrollRightIndicator }}
    >
      {allDates?.map((event, eventIndex) => (
        <div className={classes.calendarPerformances} key={`${event?.year}-${eventIndex}-`}>
          <Typography weight="medium" className={classes.year}>
            {event?.year}
          </Typography>
          <div className={classes.calendarPerformances__dates}>
            {event?.months?.map((date, dateIndex) => (
              <div className={classes.calendarPerformances__dates_months} key={`${date.month}-${dateIndex}`}>
                <Typography variant="p" weight="medium" className={classes.month}>
                  {date.month}
                </Typography>
                <div className={classes.calendarPerformances__dates_days}>
                  {date.dates.map((day, dayIndex) => (
                    <div
                      className={classnames(classes.day, {
                        [classes.repeatedDay]: !!day?.sameDateValue,
                        [classes.highLightDay]: selectedPerformanceId && selectedPerformanceId === day.id,
                      })}
                      key={`${dayIndex}`}
                      onClick={() => handleDateClick(day.id)}
                    >
                      <Typography
                        size={12}
                        weight="medium"
                        color={day.isPastDate ? 'tertiary' : 'secondary'}
                        className={classnames({
                          [classes.highLightedDate]: selectedPerformanceId && selectedPerformanceId === day.id,
                        })}
                      >
                        {createDate(day.startDate).format('DD')}
                        {day?.sameDateValue && <span className={classes.sameDateValue}>/{day?.sameDateValue}</span>}
                      </Typography>
                      <Typography size={10} color={day.isPastDate ? 'tertiary' : 'secondary'}>
                        {createDate(day.startDate).format('ddd')}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </HorizontalScrollIndicators>
  );
};

export default ProductionCalendarDates;
